const PageSpec = {
    APP: {
        //================//
        //
        // Home Page
        //
        //================//
        LANDING: {
            path: '/',
            name: 'landing',
            meta: {
                title: 'page.menu-title.detail.landing',
                permissions: []
            },
            component: () => import('@/views/pages/Landing.vue')
        },

        HOWTOPLAY: {
            path: '/how-to-play',
            name: 'how-to-play',
            meta: {
                title: 'page.menu-title.detail.how_to_play',
                permissions: []
            },
            component: () => import('@/views/pages/HowToPlay.vue')
        },

        MYTHIC: {
            path: '/mythic',
            name: 'mythic',
            meta: {
                title: 'page.menu-title.detail.mythic',
                permissions: []
            },
            component: () => import('@/views/pages/Mythic.vue')
        },

        THESTORY: {
            path: '/story',
            name: 'story',
            meta: {
                title: 'page.menu-title.detail.the_story',
                permissions: []
            },
            component: () => import('@/views/pages/TheStory.vue')
        },

        ABOUT: {
            path: '/about',
            name: 'about',
            meta: {
                title: 'page.menu-title.detail.about',
                permissions: []
            },
            component: () => import('@/views/pages/About.vue')
        },

        PAGE: {}
    }
};

export default PageSpec;
